export default "__VITE_ASSET__CX86H2WN__"